import type { IconData } from '@stacksjs/iconify-core'

export const so4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGMXVQpcWp\"><path fill-opacity=\".7\" d=\"M-85.3 0h682.6v512H-85.3z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGMXVQpcWp)\" transform=\"translate(80)scale(.9375)\"><path fill=\"#40a6ff\" d=\"M-128 0h768v512h-768z\"/><path fill=\"#fff\" d=\"M336.5 381.2L254 327.7l-82.1 54l30.5-87.7l-82-54.2L222 239l31.4-87.5l32.1 87.3l101.4.1l-81.5 54.7z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default so4x3
